import { render } from "./PreviewDemoBtn.vue?vue&type=template&id=9dadd91e&scoped=true"
import script from "./PreviewDemoBtn.vue?vue&type=script&lang=js"
export * from "./PreviewDemoBtn.vue?vue&type=script&lang=js"

import "./PreviewDemoBtn.vue?vue&type=style&index=0&id=9dadd91e&lang=scss&scoped=true"

import exportComponent from "/app/widget-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dadd91e"]])

export default __exports__